import { useTranslation } from "react-i18next";
import IVenue from "../../../interfaces/IVenue";
import { Loading } from "../../util/ListLoading";
import { IVenueGroup } from "../state/groupsManagement.reducer";
import { useStyles } from "../styles"
import { EmptyList } from "./EmptyList";

interface IGroupsList {
  groups: IVenueGroup[];
  onClick:(id:string) => void;
  isLoading:boolean;
}

export function List({ groups, onClick, isLoading }: IGroupsList) {
  const classes = useStyles();
  const { t } = useTranslation();

  if (isLoading) {
    return <Loading />;
  }

  function renderVenues(group: IVenueGroup) {
    return group.venues.map((venue: IVenue) => <span key={venue.id} data-component-name={venue.venue_name}>
      {venue.venue_name}
    </span>)
  }
  function renderGroups() {
    return groups.map((group: IVenueGroup) => <div 
      key={group.id} 
      className={classes.listItem} 
      onClick={() => onClick(group.id)}
      data-component-name={`Group-List-Items-${group.name_public}`}
      >
      <div> {group.name_public} </div>
      <div>
        {renderVenues(group)}
      </div>
    </div>)
  }
  return <div className={classes.wrapper}>
    {groups.length === 0 ?  <EmptyList text={t("groups.list.emptyList")}/> : renderGroups()}
  </div>
}

